<template>
  <div class="scroll-hor-cont">
    <div class="activ-deci">
      <div class="activ-deci-container">
        <!-- Lineas inicio -->
        <div class="linea-inicio linea-inicio-1"></div>
        <div class="linea-inicio linea-inicio-2"></div>
        <div tabindex="0" id="inicio-decisiones" class="caso">
          <v-flex xs12 text-xs-right> 
            <ui-lsc-dialog @hideVideo="hideVideo" :vidTittle="'La historia de Juliana'" videoEmbed="ADMINISTRACIONDINERO7_02 (9).mp4"></ui-lsc-dialog>          
          </v-flex>
          <p>
            <strong>Juliana</strong> acaba de graduarse como ingeniera de sistemas y su meta es ahorrar para la cuota inicial de una casa.
          </p>
        </div>
        <bot-decisiones aria-label="Oferta de trabajo" @click.native="showDiag($event, 'botonUno')" class="caso-1" :lineAfter="aceptaTrabajo === 'acepta-trabajo' || aceptaTrabajo === 'no-acepta-trabajo'"></bot-decisiones>
        <bot-decisiones aria-label="Viaje con amigas" @click.native="showDiag($event, 'botonDos')" class="caso-2" :lineAfter="ofertaViaje === 'va-de-viaje' || ofertaViaje === 'no-va-de-viaje'"></bot-decisiones>

        <!-- Le ofrecen trabajo -->
        <!-- Acepta trabajo -->
        <template v-if="aceptaTrabajo === 'acepta-trabajo'">
          <div class="lines-acepta-trabajo"></div>
          <bot-decisiones aria-label="Oferta para ahorrar" @click.native="showDiag($event, 'acepta-trabajo-1')" class="acepta-trabajo-1" id="acepta-trabajo-1" :lineAfter="false"></bot-decisiones>
          <bot-decisiones aria-label="Decide comprar moto" @click.native="showDiag($event, 'acepta-trabajo-2')" class="acepta-trabajo-2" :lineAfter="false"></bot-decisiones>
          <!-- Decide Ahorrar en fondo de empleados -->

          <bot-decisiones aria-label="Acepta ahorrar en fondo" v-if="ahorrarFondo === 'acepta-ahorrar-fondo'" @click.native="showDiag($event, 'ahorrar-fondo')" class="ahorrar-fondo" id="ahorrar-fondo" :lineAfter="false"></bot-decisiones>

          <!-- decide comprar moto -->
          <bot-decisiones aria-label="Comprar moto nueva" v-if="comprarMoto === 'compra-nueva'" @click.native="showDiag($event, 'comprar-moto-nueva')" class="comprar-moto" id="comprar-moto-nueva" :lineAfter="false"></bot-decisiones>
          <bot-decisiones aria-label="Comprar moto usada" v-if="comprarMoto === 'compra-usada'" @click.native="showDiag($event, 'comprar-moto-usada')" class="comprar-moto" id="comprar-moto-usada" :lineAfter="false"></bot-decisiones>
          <bot-decisiones aria-label="No comprar moto" v-if="comprarMoto === 'no-compra'" @click.native="showDiag($event, 'no-comprar-moto')" class="comprar-moto" id="no-comprar-moto" :lineAfter="false"></bot-decisiones>

        </template>

        <!-- No Acepta trabajo -->
        <template v-if="aceptaTrabajo === 'no-acepta-trabajo'">
          <div class="lines-no-acepta-trabajo"></div>
          <bot-decisiones aria-label="Se queda como independiente" @click.native="showDiag($event, 'no-acepta-trabajo-1')" class="no-acepta-trabajo-1" id="no-acepta-trabajo-1" :lineAfter="false"></bot-decisiones>
        </template>

        <!-- Se va de viaje -->
        <div class="lineas-se-va-de-viaje" v-if="ofertaViaje === 'va-de-viaje'"></div>
        <bot-decisiones aria-label="Pago con tarjeta de crédito" v-if="ofertaViaje === 'va-de-viaje'" @click.native="showDiag($event, 'viaje-tarjeta')" id="viaje-tarjeta" class="viaje-tarjeta" :lineAfter="false"></bot-decisiones>
        <bot-decisiones aria-label="Crédito libre inversión" v-if="ofertaViaje === 'va-de-viaje'" @click.native="showDiag($event, 'viaje-libre-invesion')" class="viaje-libre-invesion" :lineAfter="false"></bot-decisiones>

        <!-- Dialogos preguntas-->
        <template v-if="pregunta">

          <seleccion-deci v-if="preguntaDesc === 'botonUno'" class="oferta-trabajo" :style="estilosDeci" :selWidth="preguntaWidth">
            <v-flex text-xs-right> 
              <ui-lsc-dialog @hideVideo="hideVideo" :vidTittle="'Oferta de trabajo'" videoEmbed="ADMINISTRACIONDINERO7_03 (10).mp4"></ui-lsc-dialog>                          
            </v-flex>
            <v-layout row wrap>
              <v-flex xs7>
                <p>
                  Le ofrecen trabajo como ingeniera de soporte a las afueras de la ciudad, donde gana $1´200.000
                </p>
              </v-flex>
              <v-flex xs5 class="aligner">
                <div>
                  <bot-deci-opt @click.native="botsResp('pregunta-1', 'acepta-trabajo')" :botActiv="aceptaTrabajo === 'acepta-trabajo'">
                    Lo acepta
                  </bot-deci-opt>
                  <bot-deci-opt @click.native="botsResp('pregunta-1', 'no-acepta-trabajo')" :botActiv="aceptaTrabajo === 'no-acepta-trabajo'">
                    No lo acepta
                  </bot-deci-opt>
                </div>
              </v-flex>
            </v-layout>
          </seleccion-deci>

          <!-- Acepta trabajo -->
          <!-- Acepta trabajo > ofrencen ahorrar en fondo de empleados -->
          <seleccion-deci v-if="preguntaDesc === 'acepta-trabajo-1'" class="oferta-trabajo" :style="estilosDeci" :selWidth="preguntaWidth">
            <v-flex text-xs-right> 
              <ui-lsc-dialog @hideVideo="hideVideo" :vidTittle="'Ahorrar en el fondo de empleados'" videoEmbed="ADMINISTRACIONDINERO7_04 (11).mp4"></ui-lsc-dialog>                                          
            </v-flex>
            <v-layout row wrap>
              <v-flex xs7 class="aligner">
                <p>
                  Le ofrecen ahorrar en el fondo de empleados de la compañía
                </p>
              </v-flex>
              <v-flex xs5>
                <div>
                  <bot-deci-opt @click.native="botsResp('pregunta-2', 'acepta-ahorrar-fondo')" :botActiv="ahorrarFondo === 'acepta-ahorrar-fondo'">
                    Lo acepta
                  </bot-deci-opt>
                  <bot-deci-opt @click.native="botsResp('pregunta-2-no', 'no-acepta-ahorrar-fondo')" :botActiv="ahorrarFondo === 'no-acepta-ahorrar-fondo'">
                    No lo acepta
                  </bot-deci-opt>
                </div>
              </v-flex>
            </v-layout>
          </seleccion-deci>

          <!-- Acepta trabajo > ofrencen ahorrar en fondo de empleados > Acepta -->

          <seleccion-deci v-if="preguntaDesc === 'ahorrar-fondo'" class="oferta-trabajo" :style="estilosDeci" :selWidth="preguntaWidth">
            <v-layout text-xs-center row wrap>
              <v-flex xs12 text-xs-right> 
                <ui-lsc-dialog @hideVideo="hideVideo" :vidTittle="'Ahorrar en el fondo de empleados'" videoEmbed="ADMINISTRACIONDINERO7_05 (12).mp4"></ui-lsc-dialog>                                          
              </v-flex>
              <v-flex xs12>
                <bot-deci-opt @click.native="botsResp('pregunta-3', 'fondos-ahorra-5')" :botActiv="cantidadAhorroFondo === 'fondos-ahorra-5'">
                  Ahorra 5% del salario. Aporta mensualmente $60.000
                </bot-deci-opt>
              </v-flex>
              <v-flex xs12>
                <bot-deci-opt @click.native="botsResp('pregunta-3', 'fondos-ahorra-10')" :botActiv="cantidadAhorroFondo === 'fondos-ahorra-10'">
                  Ahorra 10% del salario. Aporta mensualmente $120.000
                </bot-deci-opt>
              </v-flex>
              <v-flex xs12>
                <bot-deci-opt @click.native="botsResp('pregunta-3', 'fondos-ahorra-15')" :botActiv="cantidadAhorroFondo === 'fondos-ahorra-15'">
                  Ahorra 15% del salario. Aporta mensualmente $ 180.000
                </bot-deci-opt>
              </v-flex>
            </v-layout>
          </seleccion-deci>

          <!-- Acepta trabajo > decide comprar moto -->
          <seleccion-deci v-if="preguntaDesc === 'acepta-trabajo-2'" class="oferta-trabajo" :style="estilosDeci" :selWidth="preguntaWidth">
            <v-layout row wrap>
              <v-flex xs12 text-xs-right> 
                <ui-lsc-dialog @hideVideo="hideVideo" :vidTittle="'¿Compra una moto?'" videoEmbed="ADMINISTRACIONDINERO7_10 (17).mp4"></ui-lsc-dialog>          
              </v-flex>
              <v-flex xs7 class="aligner">
                <p>
                  Está pensando en comprar moto para ir al trabajo
                </p>
              </v-flex>
              <v-flex xs5>
                <div>
                  <bot-deci-opt @click.native="botsResp('pregunta-4', 'compra-nueva')" :botActiv="comprarMoto === 'compra-nueva'">
                    Nueva $ 3.000.000
                  </bot-deci-opt>
                  <bot-deci-opt @click.native="botsResp('pregunta-4', 'compra-usada')" :botActiv="comprarMoto === 'compra-usada'">
                    Usada $ 2.200.000
                  </bot-deci-opt>
                  <bot-deci-opt @click.native="botsResp('pregunta-4', 'no-compra')" :botActiv="comprarMoto === 'no-compra'">
                    No compra
                  </bot-deci-opt>
                </div>
              </v-flex>
            </v-layout>
          </seleccion-deci>

          <!-- Acepta trabajo > decide comprar moto > Nueva -->
          <seleccion-deci v-if="preguntaDesc === 'comprar-moto-nueva'" class="oferta-trabajo" :style="estilosDeci" :selWidth="preguntaWidth">
            <v-layout row wrap>
              <v-flex xs12 text-xs-right> 
                <ui-lsc-dialog @hideVideo="hideVideo" :vidTittle="'Compra moto nueva'" videoEmbed="ADMINISTRACIONDINERO7_11 (18).mp4"></ui-lsc-dialog>          
              </v-flex>
              <v-flex xs12>
                <p>
                  <strong>Nueva $ 3.000.000</strong>
                </p>
              </v-flex>
              <v-flex xs12 text-xs-center>
                <bot-deci-opt @click.native="botsResp('pregunta-5', 'credito-nueva-1')" :botActiv="motoCredito === 'credito-nueva-1'">
                  Crédito por el 80% a 36 meses con interés mensual del 1.2%.<br> Cuota mensual de $85.000
                </bot-deci-opt>
              </v-flex>
              <v-flex xs12 text-xs-center>
                <bot-deci-opt @click.native="botsResp('pregunta-5', 'credito-nueva-2')" :botActiv="motoCredito === 'credito-nueva-2'">
                  Crédito por el 80% a 24 meses con interés mensual del 1.3%.<br> Cuota mensual de $118.000
                </bot-deci-opt>
              </v-flex>
            </v-layout>
          </seleccion-deci>

          <!-- Acepta trabajo > decide comprar moto > Usada -->
          <seleccion-deci v-if="preguntaDesc === 'comprar-moto-usada'" class="oferta-trabajo" :style="estilosDeci" :selWidth="preguntaWidth">
            <v-layout row wrap>
              <v-flex xs12 text-xs-right> 
                <ui-lsc-dialog @hideVideo="hideVideo" :vidTittle="'Compra moto usada'" videoEmbed="ADMINISTRACIONDINERO7_14 (21).mp4"></ui-lsc-dialog>          
              </v-flex>
              <v-flex xs12>
                <p>
                  <strong>Usada $ 2.200.000</strong>
                </p>
              </v-flex>
              <v-flex xs12 text-xs-center>
                <bot-deci-opt @click.native="botsResp('pregunta-5', 'credito-usada-1')" :botActiv="motoCredito === 'credito-usada-1'">
                  Crédito por el 60% a 24 meses con interés mensual del 1.5%.<br> Cuota mensual de $67.000
                </bot-deci-opt>
              </v-flex>
              <v-flex xs12 text-xs-center>
                <bot-deci-opt @click.native="botsResp('pregunta-5', 'credito-usada-2')" :botActiv="motoCredito === 'credito-usada-2'">
                  Crédito por el 60% a 12 meses con interés mensual del 1.5%.<br> Cuota mensual de $123.000
                </bot-deci-opt>
              </v-flex>
            </v-layout>
          </seleccion-deci>

          <!-- Acepta trabajo > decide comprar moto > No compra -->
          <seleccion-deci v-if="preguntaDesc === 'no-comprar-moto'" class="oferta-trabajo" :style="estilosDeci" :selWidth="preguntaWidth">
            <v-layout row wrap>
              <v-flex xs12 text-xs-right> 
                <ui-lsc-dialog @hideVideo="hideVideo" :vidTittle="'No compra moto'" videoEmbed="ADMINISTRACIONDINERO7_17 (24).mp4"></ui-lsc-dialog>          
              </v-flex>
              <v-flex xs12>
                <p>
                  <strong>No compra</strong>
                </p>
              </v-flex>
              <v-flex xs12 text-xs-center>
                <bot-deci-opt @click.native="botsResp('pregunta-5', 'credito-no-moto-1')" :botActiv="motoCredito === 'credito-no-moto-1'">
                  Toma bus de $1.500 que gasta 2 horas en llegar<br> Gasto mensual $66.000
                </bot-deci-opt>
              </v-flex>
              <v-flex xs12 text-xs-center>
                <bot-deci-opt @click.native="botsResp('pregunta-5', 'credito-no-moto-2')" :botActiv="motoCredito === 'credito-no-moto-2'">
                  Toma colectivo de $2.000 que gasta hora y media en llegar.<br> Gasto mensual $88.000
                </bot-deci-opt>
              </v-flex>
            </v-layout>
          </seleccion-deci>

          <!-- No Acepta trabajo -->
          <seleccion-deci v-if="preguntaDesc === 'no-acepta-trabajo-1'" class="oferta-trabajo" :style="estilosDeci" :selWidth="preguntaWidth">
            <v-layout row wrap>
              <v-flex xs12 text-xs-right> 
                <ui-lsc-dialog @hideVideo="hideVideo" :vidTittle="'Explora otras opciones'" videoEmbed="ADMINISTRACIONDINERO7_20 (27).mp4"></ui-lsc-dialog>          
              </v-flex>
              <v-flex xs5 class="aligner">
                <p>
                  Se queda como independiente realizando mantenimiento de computadores.
                </p>
              </v-flex>
              <v-flex xs7>
                <div>
                  <bot-deci-opt @click.native="botsResp('pregunta-6', 'no-acepta-trabajo-opc-1')" :botActiv="noAceptaTrabajo === 'no-acepta-trabajo-opc-1'">
                    Cobra $30.000 por cada visita
                  </bot-deci-opt>
                  <bot-deci-opt @click.native="botsResp('pregunta-6', 'no-acepta-trabajo-opc-2')" :botActiv="noAceptaTrabajo === 'no-acepta-trabajo-opc-2'">
                    Hace paquetes de 5 visitas a sus clientes por $120.000 c/u.
                  </bot-deci-opt>
                  <bot-deci-opt @click.native="botsResp('pregunta-6', 'no-acepta-trabajo-opc-3')" :botActiv="noAceptaTrabajo === 'no-acepta-trabajo-opc-3'">
                    Espera una nueva oferta de trabajo que quede dentro de la ciudad
                  </bot-deci-opt>
                </div>
              </v-flex>
            </v-layout>
          </seleccion-deci>

          <!-- Oferta de viaje -->
          <seleccion-deci v-if="preguntaDesc === 'botonDos'" class="oferta-trabajo" :style="estilosDeci" :selWidth="preguntaWidth">
            <v-layout row wrap>
              <v-flex xs12 text-xs-right> 
                <ui-lsc-dialog @hideVideo="hideVideo" :vidTittle="'Irse de viaje'" videoEmbed="ADMINISTRACIONDINERO7_24 (31).mp4"></ui-lsc-dialog>          
              </v-flex>
              <v-flex xs7>
                <p>
                  Sus amigas están organizando un viaje para tomar unas vacaciones antes de empezar a trabajar. El viaje con todo incluido cuesta $1.000.000
                </p>
              </v-flex>
              <v-flex xs5 class="aligner">
                <div>
                  <bot-deci-opt @click.native="botsResp('pregunta-7', 'va-de-viaje')" :botActiv="ofertaViaje === 'va-de-viaje'">
                    Va
                  </bot-deci-opt>
                  <bot-deci-opt @click.native="botsResp('pregunta-7-2', 'no-va-de-viaje')" :botActiv="ofertaViaje === 'no-va-de-viaje'">
                    No va
                  </bot-deci-opt>
                </div>
              </v-flex>
            </v-layout>
          </seleccion-deci>

          <!-- credito para viaje -->
          <seleccion-deci v-if="preguntaDesc === 'viaje-tarjeta'" class="oferta-trabajo" :style="estilosDeci" :selWidth="preguntaWidth">
            <v-layout row wrap>
              <v-flex xs12 text-xs-right> 
                <ui-lsc-dialog @hideVideo="hideVideo" :vidTittle="'Paga con tarjeta de crédito'" videoEmbed="ADMINISTRACIONDINERO7_25 (32).mp4"></ui-lsc-dialog>          
              </v-flex>
              <v-flex xs12>
                <p>
                  <strong>Pago con tarjeta de crédito</strong>
                </p>
              </v-flex>
              <v-flex xs12 text-xs-center>
                <bot-deci-opt @click.native="botsResp('pregunta-8', 'viaje-tarjeta-1')" :botActiv="viajeTarjeta === 'viaje-tarjeta-1'">
                  Difiere a 24 meses (2,2% de interés mensual)<br> Cuota mensual de $56.000
                </bot-deci-opt>
              </v-flex>
              <v-flex xs12 text-xs-center>
                <bot-deci-opt @click.native="botsResp('pregunta-8', 'viaje-tarjeta-2')" :botActiv="viajeTarjeta === 'viaje-tarjeta-2'">
                  Difiere a 12 meses (2,2% de interés mensual)<br> Cuota mensual de $97.000
                </bot-deci-opt>
              </v-flex>
            </v-layout>
          </seleccion-deci>

          <!-- viaje-libre-invesion -->
          <seleccion-deci v-if="preguntaDesc === 'viaje-libre-invesion'" class="oferta-trabajo" :style="estilosDeci" :selWidth="preguntaWidth">
            <v-layout row wrap>
              <v-flex xs12 text-xs-right> 
                <ui-lsc-dialog @hideVideo="hideVideo" :vidTittle="'Usa un crédito de libre inversión'" videoEmbed="ADMINISTRACIONDINERO7_28 (35).mp4"></ui-lsc-dialog>          
              </v-flex>
              <v-flex xs12>
                <p>
                  <strong>Toma un crédito de libre inversión por $1.000.000</strong>
                </p>
              </v-flex>
              <v-flex xs12 text-xs-center>
                <bot-deci-opt @click.native="botsResp('pregunta-9', 'viaje-libre-invesion-1')" :botActiv="viajeLibreInv === 'viaje-libre-invesion-1'">
                  A 6 meses (1,5% de interés mensual)<br> Cuota mensual de $176.000
                </bot-deci-opt>
              </v-flex>
              <v-flex xs12 text-xs-center>
                <bot-deci-opt @click.native="botsResp('pregunta-9', 'viaje-libre-invesion-2')" :botActiv="viajeLibreInv === 'viaje-libre-invesion-2'">
                  A 1 año (1.5% de interés mensual) <br> Cuota mensual de $93.000
                </bot-deci-opt>
              </v-flex>
            </v-layout>
          </seleccion-deci>

        </template>

        <!-- Retroalimentaciones finales -->
        <template v-if="textosFinales">
          <bot-opt-final class="boton-final" :style="estilosBotonFinal" @click.native="textosFinales = !textosFinales"></bot-opt-final>

          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" video="ADMINISTRACIONDINERO7_09 (16).mp4" v-if="retroFinal === 'no-acepta-ahorrar-fondo'">
            <p>
              Al aceptar el trabajo Juliana va a empezar a recibir ingresos, pero si no hace un ahorro no logrará su meta de ahorrar para la cuota inicial de su casa
            </p>
          </bot-final-titu-uno>

          <!-- Fondo ahorro -->

          <!-- Ahorra 5% -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'fondos-ahorra-5'" video="ADMINISTRACIONDINERO7_06 (13).mp4" :finTitulos="['Al cabo de un año ','Juliana habrá ahorrado ','$720.000']">
            <p>
              y va a lograr alcanzar su meta de ahorro para la cuota inicial de su casa. Entre más ahorre, más cerca estará de su meta.
            </p>
            <!-- <ui-lsc-dialog @hideVideo="hideVideo" :vidTittle="'Lenguaje de señas'" videoEmbed="ADMINISTRACIONDINERO7_06 (12).mp4"></ui-lsc-dialog> -->
          </bot-final-titu-uno>

          <!-- Ahorra 10% -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'fondos-ahorra-10'" video="ADMINISTRACIONDINERO7_07 (14).mp4" :finTitulos="['Al cabo de un año ','Juliana habrá ahorrado ','$1.440.000']">
            <p>
              y va a lograr alcanzar su meta de ahorro para la cuota inicial de su casa. Entre más ahorre, más cerca estará de su meta.
            </p>
          </bot-final-titu-uno>

          <!-- Ahorra 12% -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'fondos-ahorra-15'" video="ADMINISTRACIONDINERO7_08 (15).mp4" :finTitulos="['Al cabo de un año ','Juliana habrá ahorrado ','$2.160.000']">
            <p>
              y va a lograr alcanzar su meta de ahorro para la cuota inicial de su casa. Entre más ahorre, más cerca estará de su meta.
            </p>
          </bot-final-titu-uno>

          <!-- Comprar moto -->

          <!-- Moto nueva opcion 1 -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'credito-nueva-1'" video="ADMINISTRACIONDINERO7_12 (19).mp4" :finTitulos="['Al cabo de un año ','Juliana habrá pagado ','$1.020.000']">
            <p>
              por su nueva moto. Aunque inicialmente se considera un gasto en realidad es un ahorro pues Juliana se evita pagar transporte público y llega en menos tiempo a su trabajo.
            </p>
          </bot-final-titu-uno>

          <!-- Moto nueva opcion 2 -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'credito-nueva-2'" video="ADMINISTRACIONDINERO7_13 (20).mp4" :finTitulos="['Al cabo de un año ','Juliana habrá pagado ','$1.416.000']">
            <p>
              por su nueva moto. Aunque inicialmente se considera un gasto en realidad es un ahorro pues Juliana se evita pagar transporte público y llega en menos tiempo a su trabajo.
            </p>
          </bot-final-titu-uno>

          <!-- Moto usada opcion 1 -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'credito-usada-1'" video="ADMINISTRACIONDINERO7_15 (22).mp4" :finTitulos="['Al cabo de un año ','Juliana habrá pagado ','$804.000']">
            <p>
              por su moto usada. Aunque inicialmente se considera un gasto en realidad es un ahorro pues Juliana se evita pagar transporte público y llega en menos tiempo a su trabajo.
            </p>
          </bot-final-titu-uno>

          <!-- Moto usada opcion 2 -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'credito-usada-2'" video="ADMINISTRACIONDINERO7_16 (23).mp4" :finTitulos="['Al cabo de un año ','Juliana habrá pagado ','$1.476.000']">
            <p>
              por su moto usada. Aunque inicialmente se considera un gasto en realidad es un ahorro pues Juliana se evita pagar transporte público y llega en menos tiempo a su trabajo.
            </p>
          </bot-final-titu-uno>

          <!-- no compra moto opcion 1 -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'credito-no-moto-1'" video="ADMINISTRACIONDINERO7_18 (25).mp4" :finTitulos="['Al cabo de un año ','Juliana habrá gastado ','$792.000']">
            <p>
              Si bien puede cubrir este gasto de transporte con su nuevo trabajo, este gasto no representa para Juliana ninguna posibilidad de ahorro.
            </p>
          </bot-final-titu-uno>

          <!-- no compra moto opcion 2 -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'credito-no-moto-2'" video="ADMINISTRACIONDINERO7_19 (26).mp4" :finTitulos="['Al cabo de un año ','Juliana habrá gastado ','$1.056.000']">
            <p>
              Si bien puede cubrir este gasto de transporte con su nuevo trabajo, este gasto no representa para Juliana ninguna posibilidad de ahorro.
            </p>
          </bot-final-titu-uno>

          <!-- no acepta trabajo opcion 1 -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'no-acepta-trabajo-opc-1'" video="ADMINISTRACIONDINERO7_21 (28).mp4" finTitulosDos="Los ingresos de">
            <p>
              <strong>Juliana son variables, dependiendo del número de clientes.</strong> Con 5 clientes por semana gana
              <strong>$600.000</strong> mientras con 10 gana
              <strong>$1.200.000.</strong> <br><br> Si bien no es una cifra fija, Juliana genera ingresos y está mas cerca de su meta.
            </p>
          </bot-final-titu-uno>

          <!-- no acepta trabajo opcion 2 -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'no-acepta-trabajo-opc-2'" video="ADMINISTRACIONDINERO7_22 (29).mp4" finTitulosDos="Los ingresos de">
            <p>
              <strong>Juliana son variables, dependiendo del número de clientes.</strong> Esta opción le permite asegurar clientes y obtener referidos.<br><br> Si consigue 10 visitas por semana puede lograr ingresos por $960.000 y estar más cerca de su meta.
            </p>
          </bot-final-titu-uno>

          <!-- no acepta trabajo opcion 2 -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'no-acepta-trabajo-opc-3'" video="ADMINISTRACIONDINERO7_23 (30).mp4" finTitulosDos="Esta opción ">
            <p>
              <strong>no le va a permitir alcanzar la meta de ahorro de Juliana.</strong> Ella podría tomar el trabajo que le están ofreciendo mientras encuentra otra opción, de esta forma puede comenzar a aportar en la casa que es lo que ella desea
            </p>
          </bot-final-titu-uno>

          <!-- Oferta de viaje -->
          <!-- no va de viaje -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'no-va-de-viaje'"  video="ADMINISTRACIONDINERO7_32 (38).mp4">
            <p>
              Si Juliana no va al viaje podría ahorrar más para la cuota inicial de su casa y de esta forma alcanzar más rápido su meta.
            </p>
          </bot-final-titu-uno>

          <!-- viaje tarjeta -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'viaje-tarjeta-1'" video="ADMINISTRACIONDINERO7_26 (33).mp4" :finTitulos="['Al cabo de un año ','Juliana habrá pagado ','$672.000']">
            <p>
              lo que significa un gasto adicional que la alejará de su meta.
            </p>
          </bot-final-titu-uno>

          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'viaje-tarjeta-2'" video="ADMINISTRACIONDINERO7_27 (34).mp4" :finTitulos="['Al cabo de un año ','Juliana habrá pagado ','$1.164.000']">
            <p>
              lo que significa un gasto adicional que la alejará de su meta.
            </p>
          </bot-final-titu-uno>

          <!-- viaje libre inversion -->
          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'viaje-libre-invesion-1'" video="ADMINISTRACIONDINERO7_30 (36).mp4" :finTitulos="[' Al cabo de seis meses ','Juliana habrá pagado ','$1.056.000']">
            <p>
              lo que significa un gasto adicional que la alejará de su meta.
            </p>
          </bot-final-titu-uno>

          <bot-final-titu-uno :style="estilosTextoFinal" class="textos-final" v-if="retroFinal === 'viaje-libre-invesion-2'" video="ADMINISTRACIONDINERO7_31 (37).mp4" :finTitulos="['Al cabo de un año ','Juliana habrá pagado ','$1.116.000']">
            <p>
              lo que significa un gasto adicional que la alejará de su meta.
            </p>
          </bot-final-titu-uno>

        </template>

      </div>
    </div>

  </div>
</template>

<script>
import BotonesDecisiones from "./ActividadDeciBoton";
import SeleccionDeci from "./ActividadDeciSelec";
import ActividadDeciBotonOpt from "./ActividadDeciBotonOpt";
import ActividadDeciBotonFinal from "./ActividadDeciBotonFinal";
import ActividadDeciTituUno from "./ActividadDeciTituUno";

export default {
  components: {
    "bot-decisiones": BotonesDecisiones,
    "seleccion-deci": SeleccionDeci,
    "bot-deci-opt": ActividadDeciBotonOpt,
    "bot-opt-final": ActividadDeciBotonFinal,
    "bot-final-titu-uno": ActividadDeciTituUno
  },
  data() {
    return {
      pregunta: false,
      preguntaDesc: "",
      preguntawidth: 0,
      topDiag: 0,
      leftDiag: 0,
      preguntaWidth: 400,
      textosFinales: false,
      // acepta trabajo
      aceptaTrabajo: "",
      // no acepta trabajo
      noAceptaTrabajo: "",
      // acepta ahorrar fondo
      ahorrarFondo: "",
      cantidadAhorroFondo: "",
      // decide comprar moto
      comprarMoto: "",
      motoCredito: "",
      retroFinal: "",
      // Oferta de viaje
      ofertaViaje: "",
      viajeTarjeta: "",
      viajeLibreInv: ""
    };
  },
  methods: {
    hideVideo(){},
    showDiag($event, botName) {
      this.preguntaDesc = botName;
      this.pregunta = true;
      var botTop = $event.target.offsetTop;
      var botLeft = $event.target.offsetLeft;
      this.topDiag = botTop;
      this.leftDiag = botLeft;
      this.textosFinales = false;
      setTimeout(function() {
        document.getElementById("pregunta-select").focus();
      }, 100);
    },
    focusTime(elem) {
      setTimeout(function() {
        document.getElementById(elem).focus();
      }, 100);
    },
    botsResp(preg, desc) {
      this.pregunta = false;
      if (preg === "pregunta-1") {
        this.aceptaTrabajo = desc;
        if (this.aceptaTrabajo === "acepta-trabajo") {
          this.focusTime("acepta-trabajo-1");
        } else if (this.aceptaTrabajo === "no-acepta-trabajo") {
          this.focusTime("no-acepta-trabajo-1");
        }
      }
      if (preg === "pregunta-2") {
        this.ahorrarFondo = desc;
        this.focusTime("ahorrar-fondo");
      }
      if (preg === "pregunta-2-no") {
        this.ahorrarFondo = desc;
        this.textosFinales = true;
        this.retroFinal = desc;
        this.$store.commit("nextShow", true);
        this.focusTime("texto-final");
      }
      if (preg === "pregunta-3") {
        this.cantidadAhorroFondo = desc;
        this.textosFinales = true;
        this.retroFinal = desc;
        this.$store.commit("nextShow", true);
        this.focusTime("texto-final");
      }
      if (preg === "pregunta-4") {
        this.comprarMoto = desc;
        if (this.comprarMoto === "compra-nueva") {
          this.focusTime("comprar-moto-nueva");
        } else if (this.comprarMoto === "compra-usada") {
          this.focusTime("comprar-moto-usada");
        } else if (this.comprarMoto === "no-compra") {
          this.focusTime("no-comprar-moto");
        }
      }
      if (preg === "pregunta-5") {
        this.motoCredito = desc;
        this.textosFinales = true;
        this.retroFinal = desc;
        this.$store.commit("nextShow", true);
        this.focusTime("texto-final");
      }
      if (preg === "pregunta-6") {
        this.noAceptaTrabajo = desc;
        this.textosFinales = true;
        this.retroFinal = desc;
        this.$store.commit("nextShow", true);
        this.focusTime("texto-final");
      }
      if (preg === "pregunta-7") {
        this.ofertaViaje = desc;
        this.focusTime("viaje-tarjeta");
      }
      if (preg === "pregunta-7-2") {
        this.ofertaViaje = desc;
        this.textosFinales = true;
        this.retroFinal = desc;
        this.$store.commit("nextShow", true);
        this.focusTime("texto-final");
      }
      if (preg === "pregunta-8") {
        this.viajeTarjeta = desc;
        this.textosFinales = true;
        this.retroFinal = desc;
        this.$store.commit("nextShow", true);
        this.focusTime("texto-final");
      }
      if (preg === "pregunta-9") {
        this.viajeLibreInv = desc;
        this.textosFinales = true;
        this.retroFinal = desc;
        this.$store.commit("nextShow", true);
        this.focusTime("texto-final");
      }
    }
  },
  computed: {
    estilosDeci() {
      return {
        top: this.topDiag - 50 + "px",
        left: this.leftDiag + 40 + "px"
      };
    },
    estilosBotonFinal() {
      return {
        top: this.topDiag - 5 + "px",
        left: this.leftDiag + 105 + "px"
      };
    },
    estilosTextoFinal() {
      return {
        top: this.topDiag - 55 + "px",
        left: this.leftDiag + 135 + "px"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/mixins";
@import "../../sass/helpers/variables";
.activ-deci {
  p {
    margin: 0;
  }
  width: 100%;
  .activ-deci-container {
    width: 960px;
    margin: auto;
    height: 550px;
    border-radius: 10px;
    padding: 10px 20px;
    position: relative;
    @include insetshadow(0 2px 10px #555);
    font-size: 1.2rem;
    line-height: 1.5rem;
    .caso {
      position: absolute;
      width: 140px;
      top: 160px;
    }
  }
  .linea-inicio {
    position: absolute;
    width: 40px;
    height: 50px;
    border-right: solid 4px $secondary-red;
    left: 160px;
    &.linea-inicio-1 {
      border-bottom: solid 4px $secondary-red;
      top: 190px;
    }
    &.linea-inicio-2 {
      border-top: solid 4px $secondary-red;
      top: 260px;
    }
  }
  .caso-1 {
    position: absolute;
    top: 174px;
    left: 238px;
  }
  .caso-2 {
    position: absolute;
    top: 290px;
    left: 238px;
  }
  .oferta-trabajo {
    position: absolute;
  }
  .boton-final {
    position: absolute;
  }
  .textos-final {
    position: absolute;
  }

  // Acepta trabajo
  .lines-acepta-trabajo {
    width: 4px;
    height: 80px;
    position: absolute;
    top: 113px;
    left: 309px;
    border-right: solid 4px $secondary-red;
  }

  .lines-no-acepta-trabajo {
    width: 4px;
    height: 40px;
    position: absolute;
    top: 152px;
    left: 309px;
    border-right: solid 4px $secondary-red;
  }

  .lineas-se-va-de-viaje {
    width: 4px;
    height: 70px;
    position: absolute;
    top: 309px;
    left: 309px;
    border-right: solid 4px $secondary-red;
  }

  .acepta-trabajo-1 {
    position: absolute;
    top: 97px;
    left: 350px;
  }

  .no-acepta-trabajo-1 {
    position: absolute;
    top: 136px;
    left: 350px;
  }

  .acepta-trabajo-2 {
    position: absolute;
    top: 145px;
    left: 350px;
  }

  .ahorrar-fondo {
    position: absolute;
    top: 97px;
    left: 425px;
  }
  .no-acepta-ahorrar-fondo {
    position: absolute;
    padding: 10px;
    width: 400px;
    top: 75px;
    left: 380px;
  }
  .fin-titu-motos {
    position: absolute;
    top: 100px;
    left: 570px;
  }
  .comprar-moto {
    position: absolute;
    top: 145px;
    left: 425px;
  }
  // salir de viaje
  .viaje-tarjeta {
    position: absolute;
    top: 310px;
    left: 350px;
  }
  .viaje-libre-invesion {
    position: absolute;
    top: 359px;
    left: 350px;
  }
}
</style>



// WEBPACK FOOTER //
// ActividadDecisiones.vue?63668c64